import React from 'react';
import { Checkbox, Button } from 'antd';
import dispatch from 'app/dispatch';
import { ACTION } from 'app/ducks/cities_admin/actions';


export default [
    {
        title: 'Назва міста',
        dataIndex: 'name',
        render: text => <div className="cell">{text}</div>,
    },
    {
        title: 'Дії',
        dataIndex: 'id',
        key: 'id',
        render: id => {
            return <Button onClick={() => dispatch(ACTION.edit({ new: false, id }))}>Редагувати</Button>;
        }
    },
];
